import { EditItem, IEditItem } from "../common/editItem";
import { RiskAssesmentFrequency, RiskType } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IRiskTemplateEditItem extends IEditItem {
    riskCategoryId: string;
    riskType: RiskType;
    code: string;
    description: string;
    threat: string;
    controls: string;
    owner: string;
    assesmentFrequency: RiskAssesmentFrequency;
    activeState: number;
    opportunity: boolean;
    opportunityBenefit: string;
    opportunityDescription: string;
    modifyUser: IModifyUser;
}

export class RiskTemplateEditItem extends EditItem implements IRiskTemplateEditItem {
    riskCategoryId: string;
    riskType: RiskType;
    code: string;
    description: string;
    threat: string;
    controls: string;
    owner: string;
    assesmentFrequency: RiskAssesmentFrequency;
    activeState: number;
    opportunity: boolean;
    opportunityBenefit: string;
    opportunityDescription: string;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IRiskTemplateEditItem);
    constructor(obj?: any) {
        super(obj);
        this.riskCategoryId = obj && obj.riskCategoryId || "";
        this.riskType = obj && obj.riskType || RiskType.Risk;
        this.code = obj && obj.code || "";
        this.description = obj && obj.description || "";
        this.threat = obj && obj.threat || "";
        this.controls = obj && obj.controls || "";
        this.owner = obj && obj.owner || "";
        this.assesmentFrequency = obj && obj.assesmentFrequency || RiskAssesmentFrequency.Continuous;
        this.activeState = obj && obj.activeState || 0;
        this.opportunity = obj && obj.opportunity || false;
        this.opportunityBenefit = obj && obj.opportunityBenefit || "";
        this.opportunityDescription = obj && obj.opportunityDescription || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}